import { useEffect, useState } from 'react';
import { Card, Col, Row, Form, Button, Modal, Table } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import "./contentManagement.css";
import API from '../../services/axiosInstance';
import { ViewModal } from './viewModal';
import { FormLoader, useFormLoader } from "./../common_modules/loader.js"
import { validateField, validateUrl } from '../utils/helper.js';

const AddContentManagement = () => {
    const [show, setShow] = useState(false);
    const [showImg, setShowImg] = useState(false);
    const [uploadInfoTemp, setUploadInfoTemp] = useState({});
    const [contentByIdInfo, setContentByIdInfo] = useState({});
    const [imageModalShow, setImageModalShow] = useState(false);
    const [videoModalShow, setVideoModalShow] = useState(false);

    // hooks
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    const handleClose = () => {
        setShow(false)
        clearTempUpload(); // clear temp upload
    };

    const handleShow = () => setShow(true);

    const handleCloseImg = () => {
        setShowImg(false);
        clearTempUpload(); // clear temp upload
    }

    const handleShowImg = () => setShowImg(true);

    const { handleSubmit, register, resetField, setValue, reset, watch, formState: { errors } } = useForm({
        shouldUnregister: false,
        defaultValues: {
            videoName: "",
            status: "0",
            videoUploadType: "0",
            videoFile: "",
            videoInfo: "",
            imgUploadType: "0",
            imageFile: "",
            imageInfo: "",
        },
    });

    // states values
    const [
        videoUploadType,
        imgUploadType,
        videoFile,
        videoInfo,
        imageFile,
        imageInfo,
        videoName,
        status
    ] = watch([
        "videoUploadType",
        "imgUploadType",
        "videoFile",
        "videoInfo",
        "imageFile",
        "imageInfo",
        "videoName",
        "status"
    ]);

    const onChangeHandler = async (e) => {
        startLoading();
        try {
            const file = e.target.files[0];
            const name = e.target.name;
            const maxSize = 10 * 1024 * 1024; // 20 MB in bytes

            if (file.size > maxSize) {
                alert("File is larger than or equal 10 MB. Upload video upto 10 MB.");
                if (name == "videoFile") {
                    setValue("videoFile", "");
                }
                return false;
            }

            // making a formdata object
            const formData = new FormData();
            formData.append("file", file);

            // upload each selected file on server using api.
            const response = await API.post("/meta/content/upload/file", formData);

            if (response.status == 200) {
                let result = response.data.data;
                // adding upload type
                result[`uploadType`] = 0; // always 0 
                setUploadInfoTemp(result);
            }
        } catch (error) {
            // handling error's
        } finally {
            stopLoading();
        }
    }

    const clearTempUpload = () => {
        // if (window.confirm("Are you sure you want to delete this?")) {
        setUploadInfoTemp({});
        // }
    }

    const removeUploadFile = (e) => {
        // if (window.confirm("Are you sure you want to delete this?")) {
        const type = e.target.name;
        if (type === "video") {
            setValue("videoInfo", "");
        } else if (type === "image") {
            setValue("imageInfo", "");
        }
        // }
    }

    const saveMediaFile = (e) => {
        const type = e.target.name;
        if (type === "video") {
            setValue("videoInfo", uploadInfoTemp);
        } else if (type === "image") {
            setValue("imageInfo", uploadInfoTemp);
        }

        // close after data set into state
        handleClose();
        handleCloseImg();
    }

    const formValidate = () => {
        if (!videoInfo) {
            alert("Please upload video")
            return false;
        }

        if (!imageInfo) {
            alert("Please upload an image")
            return false;
        }
        return true;
    }

    const onSubmitHandlerAdd = async (data) => {
        try {
            startLoading();
            if (data && formValidate()) {
                // save content management form
                let image = {};
                if (imageInfo?.uploadType === 0) {
                    image = imageInfo;
                } else {
                    image = {
                        // originalName: "",
                        cdnFileName: imageInfo,
                        // contentType: "",
                        // fileSize: "",
                        // width: 0,
                        // height: 0,
                        uploadType: 1
                    }
                }

                let video = {};
                if (videoInfo?.uploadType === 0) {
                    video = videoInfo;
                } else {
                    video = {
                        // originalName: "",
                        cdnFileName: videoInfo,
                        // contentType: "",
                        // fileSize: "",
                        // width: 0,
                        // height: 0,
                        uploadType: 1
                    }
                }

                const payload = {
                    name: videoName.trim(),
                    status: status,
                    contentFiles: [video, image]
                }

                // save content
                let response = await API.post(`/meta/content/save`, payload);

                if (response.status === 200) {
                    navigate("/content-management");
                }
            } else {
                console.log("form validation failed !!!");
            }
        } catch (error) {
            // handling error's
        } finally {
            stopLoading();
        }
    }

    const onSubmitHandlerUpdate = async (data) => {
        try {
            startLoading();
            if (data && formValidate()) {
                // update content management form
                contentByIdInfo.name = videoName.trim();
                contentByIdInfo.status = status;
                contentByIdInfo.contentFiles.forEach((iteam, i, arr) => {
                    // set video
                    if (iteam.contentType.startsWith("video/")) {
                        // set update video information
                        if (arr[i]) {
                            if (videoInfo?.uploadType === 0) {
                                // if uploaded media
                                arr[i] = {
                                    ...arr[i],
                                    ...videoInfo
                                };
                                // arr[i].cdnFileName = "";
                                // arr[i].uploadType = 0;
                            } else {
                                // if enter url
                                arr[i].cdnFileName = videoInfo
                                arr[i].uploadType = 1;
                            }
                        }
                    }

                    // set image
                    if (iteam.contentType.startsWith("image/")) {
                        // set update image information
                        if (arr[i]) {
                            if (imageInfo?.uploadType === 0) {
                                arr[i] = {
                                    ...arr[i],
                                    ...imageInfo
                                };
                                // arr[i].cdnFileName = "";
                                // arr[i].uploadType = 0;
                            } else {
                                arr[i].cdnFileName = imageInfo;
                                arr[i].uploadType = 1;
                            }
                        }
                    }
                });
                
                // update content
                let response = await API.put(`/meta/content/edit/${id}`, contentByIdInfo);

                if (response.status === 200) {
                    navigate("/content-management");
                }
            } else {
                console.log("form validation failed !!!");
            }
        } catch (error) {
            // handling error's
        } finally {
            stopLoading();
        }
    }

    const getContentById = async (id) => {
        startLoading();
        try {
            const response = await API.get(`/meta/content/by/${id}`);
            if (response.status === 200) {
                const result = response.data.data;
                setContentByIdInfo(result); // set into state

                // set save data into each field
                setValue("videoName", result.name);
                setValue("status", result.status);

                if (result.contentFiles[0].contentType.startsWith("video/")) {
                    setValue("videoUploadType", result.contentFiles[0].uploadType);
                    if (result.contentFiles[0].uploadType === 0) {
                        setValue("videoInfo", result.contentFiles[0]);
                    } else {
                        setValue("videoInfo", result.contentFiles[0].cdnFileName);
                    }
                } else {
                    setValue("videoUploadType", result.contentFiles[1].uploadType);
                    if (result.contentFiles[1].uploadType === 0) {
                        setValue("videoInfo", result.contentFiles[1]);
                    } else {
                        setValue("videoInfo", result.contentFiles[1].cdnFileName);
                    }
                }

                if (result.contentFiles[0].contentType.startsWith("image/")) {
                    setValue("imgUploadType", result.contentFiles[0].uploadType);
                    if (result.contentFiles[0].uploadType === 0) {
                        setValue("imageInfo", result.contentFiles[0]);
                    } else {
                        setValue("imageInfo", result.contentFiles[0].cdnFileName);
                    }
                } else {
                    setValue("imgUploadType", result.contentFiles[1].uploadType);
                    if (result.contentFiles[1].uploadType === 0) {
                        setValue("imageInfo", result.contentFiles[1]);
                    } else {
                        setValue("imageInfo", result.contentFiles[1].cdnFileName);
                    }
                }
            }
        } catch (error) {
            // handling error's
        } finally {
            stopLoading();
        }

    }

    const downloadFile = async (cdnUrl, fileName) => {
        if (window.confirm("do you want to download this file !!!")) {
            const response = await fetch(cdnUrl);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    }

    useEffect(() => {
        if (id) {
            // update content
            getContentById(id)
        }
    }, []);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <span>Meta Admin</span>
                <Link to={'/content-management'}><span>Content Management</span></Link>
                {id ? contentByIdInfo ? <span>{contentByIdInfo?.name}</span> : "" : ''}
                <span>{id ? "Update" : "Add"}</span>
                {/* {id ? <span>{id}</span> : ''} */}
                
            </div>
            <Card className="p-3 instreamRows contentMng">
                <h6 className="title">{id ? "Update" : "Add"} Content Management</h6>
                <span className="text-danger mb-5" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <form onSubmit={handleSubmit(id ? onSubmitHandlerUpdate : onSubmitHandlerAdd)}>
                    <Row>
                        <Col md={3}>
                            <label>Video Name <span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Control type="text" className="form-control" name="videoName" placeholder="Enter video name"
                                {...register("videoName", {
                                    required: "Video Name is required",
                                    validate: value => validateField(value, false, false).message
                                })}
                            />
                            {errors.videoName && <p className="text-danger">{errors.videoName.message}</p>}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <label>Status<span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Select name="status" {...register("status", { required: "Status is required" })}>
                                {/* <option value="" disabled>Select Status</option> */}
                                <option value="0">Pending</option>
                                <option value="1">Active</option>
                            </Form.Select>

                            {errors.status && (
                                <p className="text-danger">{errors.status.message}</p>
                            )}
                        </Col>
                    </Row>

                    {/* Video */}
                    <Row>
                        <Col md={3}>
                            <label>Video Upload Type<span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Select {...register("videoUploadType", {
                                required: "Video Upload Type is required",
                                onChange: () => {
                                    setValue("videoInfo", "");
                                }
                            })}>
                                {/* <option value="" disabled>Select Upload Type</option> */}
                                <option value="0">Direct</option>
                                <option value="1">URL</option>
                            </Form.Select>

                            {errors.videoUploadType && (
                                <p className="text-danger">{errors.videoUploadType.message}</p>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <label>{videoUploadType == "0" ? "Upload Video" : "Video Url"}<span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            {
                                videoUploadType == "0" ?
                                    <>
                                        {/* modal button */}
                                        {
                                            videoInfo === "" ?
                                                <Button size='sm' variant="success" onClick={handleShow}>
                                                    Upload Media File
                                                </Button>
                                                : ""
                                        }
                                        {/* modal */}
                                        <Modal show={show} onHide={handleClose}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Upload Video</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                {
                                                    Object.entries(uploadInfoTemp).length === 0 ?
                                                        <Form.Control type="file" accept='video/*' {...register("videoFile",
                                                            {
                                                                // required: "video is required",
                                                                onChange: (e) => { onChangeHandler(e); }
                                                            })} />
                                                        : ""
                                                }
                                                {
                                                    Object.entries(uploadInfoTemp).length !== 0 ?
                                                    <div className="table-responsive mt-3">
                                                        <Table striped bordered hover className='mt-3'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Thumbnail</th>
                                                                    <th>Slot</th>
                                                                    <th>Size</th>
                                                                    {/* <th>Progress</th> */}
                                                                    <th>Status</th>
                                                                    <th>Remove</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td title={uploadInfoTemp.originalName}>
                                                                        {uploadInfoTemp.originalName.substring(0, 5)}....
                                                                        {uploadInfoTemp.originalName
                                                                            .substring(uploadInfoTemp.originalName.length - 10,
                                                                                uploadInfoTemp.originalName.length)}
                                                                    </td>
                                                                    <td>{`${uploadInfoTemp.width}*${uploadInfoTemp.height}`}</td>
                                                                    <td>{uploadInfoTemp.fileSize}</td>
                                                                    {/* <td></td> */}
                                                                    <td>Success</td>
                                                                    <td><button type='button' onClick={clearTempUpload} className='btn btn-outline-danger btn-sm'>DEL</button></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                        : ""
                                                }
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={handleClose}>
                                                    Close
                                                </Button>
                                                {Object.entries(uploadInfoTemp).length !== 0 ?
                                                    <Button variant="primary" name="video" onClick={saveMediaFile}>
                                                        Save Media File
                                                    </Button>
                                                    : ""}
                                            </Modal.Footer>
                                        </Modal>

                                        {/* Video upload status */}
                                        {videoInfo !== "" ?
                                        <div className="table-responsive mt-3">
                                            <Table striped bordered hover className='mt-3'>
                                                <thead>
                                                    <tr>
                                                        {id && videoInfo?.cdnFileName?.startsWith("http") ? <th>Video</th> : ""}
                                                        <th>Media File Urls</th>
                                                        <th>Slot</th>
                                                        <th>Remove</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        {id && videoInfo?.cdnFileName?.startsWith("http") ?
                                                            <td>
                                                                <button type='button' onClick={() => downloadFile(videoInfo.cdnFileName, videoInfo.originalName)} className='btn btn-outline-success btn-sm'>Download</button>
                                                                <button type='button' onClick={() => setVideoModalShow(true)} className='btn btn-outline-primary btn-sm mx-2'>Play</button>
                                                                {
                                                                    videoModalShow ?
                                                                        <ViewModal viewType={"video"} url={videoInfo.cdnFileName} show={videoModalShow} onHide={() => setVideoModalShow(false)} /> : ""
                                                                }

                                                            </td>
                                                            : ""}
                                                        <td title={videoInfo.originalName}>
                                                            {videoInfo.originalName.substring(0, 5)}....
                                                            {videoInfo.originalName
                                                                .substring(videoInfo.originalName.length - 10,
                                                                    videoInfo.originalName.length)}
                                                        </td>
                                                        <td>{`${videoInfo.width}*${videoInfo.height}`}</td>
                                                        <td><button name="video" type='button' onClick={removeUploadFile} className='btn btn-outline-danger btn-sm'>DEL</button></td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>    
                                            : ""}

                                        {/* <Form.Control type="file" {...register("videoFile", { required: "video File is required", })} /> */}
                                    </>
                                    :
                                    <>
                                        <Form.Control type="text" className="form-control" name="videoInfo" placeholder="Enter URL" {...register("videoInfo", {
                                            required: "Video URL is required",
                                            validate: value => validateUrl(value, "video").message
                                        })} />
                                        {errors.videoInfo && (<p className="text-danger">{errors.videoInfo.message}</p>)}
                                    </>
                            }
                            {/* {errors.videoFile && (<p className="text-danger">{errors.videoFile.message}</p>)} */}
                        </Col>
                    </Row>

                    {/* Image */}
                    <Row>
                        <Col md={3}>
                            <label>PosterImage Upload Type<span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            <Form.Select {...register("imgUploadType", {
                                required: "Image Upload Type is required",
                                onChange: () => {
                                    setValue("imageInfo", "");
                                }
                            })}>
                                {/* <option value="" disabled>Select Upload Type</option> */}
                                <option value="0">Direct</option>
                                <option value="1">URL</option>
                            </Form.Select>

                            {errors.imgUploadType && (<p className="text-danger">{errors.imgUploadType.message}</p>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <label>{imgUploadType == "0" ? "Upload Image" : "Image Url"}<span className="text-danger">*</span></label>
                        </Col>
                        <Col md={5}>
                            {
                                imgUploadType == "0" ?
                                    <>
                                        {/* modal */}
                                        {
                                            imageInfo === "" ?
                                                <Button size='sm' variant="success" onClick={handleShowImg}>
                                                    Upload Poster Image
                                                </Button>
                                                : ""
                                        }

                                        <Modal show={showImg} onHide={handleCloseImg}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Upload Image</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                {
                                                    Object.entries(uploadInfoTemp).length === 0 ?
                                                        <Form.Control type="file" accept='image/*' {...register("imageFile",
                                                            {
                                                                // required: "Image is required",
                                                                onChange: (e) => {
                                                                    // const file = e.target.files[0];
                                                                    // setValue("imageFile", file);
                                                                    onChangeHandler(e);
                                                                }
                                                            })} />
                                                        : ""
                                                }
                                                {
                                                    Object.entries(uploadInfoTemp).length !== 0 ?
                                                    <div className="table-responsive mt-3">
                                                        <Table striped bordered hover className='mt-3'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Thumbnail</th>
                                                                    <th>Slot</th>
                                                                    <th>Size</th>
                                                                    {/* <th>Progress</th> */}
                                                                    <th>Status</th>
                                                                    <th>Actions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td title={uploadInfoTemp.originalName}>
                                                                        {uploadInfoTemp.originalName.substring(0, 5)}....
                                                                        {uploadInfoTemp.originalName
                                                                            .substring(uploadInfoTemp.originalName.length - 10,
                                                                                uploadInfoTemp.originalName.length)}
                                                                    </td>
                                                                    <td>{`${uploadInfoTemp.width}*${uploadInfoTemp.height}`}</td>
                                                                    <td>{uploadInfoTemp.fileSize}</td>
                                                                    {/* <td></td> */}
                                                                    <td>Success</td>
                                                                    <td><button type='button' onClick={clearTempUpload} className='btn btn-outline-danger btn-sm'>DEL</button></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                        : ""
                                                }
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={handleCloseImg}>
                                                    Close
                                                </Button>
                                                {
                                                    Object.entries(uploadInfoTemp).length !== 0 ?
                                                        <Button variant="primary" name="image" onClick={saveMediaFile}>
                                                            Save
                                                        </Button>
                                                        : ""
                                                }

                                            </Modal.Footer>
                                        </Modal>

                                        {/* Image upload status */}
                                        {
                                            imageInfo !== "" ?
                                            <div className="table-responsive mt-3">
                                                <Table striped bordered hover className='mt-3'>
                                                    <thead>
                                                        <tr>
                                                            {id && imageInfo?.cdnFileName?.startsWith("http") ? <th>Image</th> : ""}
                                                            <th>Thumbnail</th>
                                                            <th>Slot</th>
                                                            <th>Remove</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            {id && imageInfo?.cdnFileName?.startsWith("http") ?
                                                                <td>
                                                                    <button onClick={() => downloadFile(imageInfo.cdnFileName, imageInfo.originalName)} type='button' className='btn btn-outline-success btn-sm'>
                                                                        Download File
                                                                    </button>
                                                                    <button type='button' onClick={() => setImageModalShow(true)} className='btn btn-outline-primary btn-sm mx-2'>View</button>
                                                                    {
                                                                        imageModalShow ?
                                                                            <ViewModal viewType={"image"} url={imageInfo.cdnFileName} show={imageModalShow} onHide={() => setImageModalShow(false)} className="ViewImage" />
                                                                            : ""
                                                                    }
                                                                </td>
                                                                : ""}
                                                            <td title={imageInfo.originalName}>
                                                                {imageInfo.originalName.substring(0, 5)}....
                                                                {imageInfo.originalName
                                                                    .substring(imageInfo.originalName.length - 10,
                                                                        imageInfo.originalName.length)}
                                                            </td>
                                                            <td>{`${imageInfo.width}*${imageInfo.height}`}</td>
                                                            <td><button name="image" type='button' onClick={removeUploadFile} className='btn btn-outline-danger btn-sm'>DEL</button></td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>                            
                                                : ""
                                        }
                                        {/* <Form.Control type="file" {...register("videoFile", { required: "video File is required", })} /> */}
                                    </>
                                    // <Form.Control type="file" {...register("imageFile", { required: "video File is required", })} />
                                    :
                                    <>
                                        <Form.Control type="text" className="form-control" name="imageInfo" placeholder="Enter URL" {...register("imageInfo", {
                                            required: "Image URL is required",
                                            validate: value => validateUrl(value, "image").message
                                        })} />
                                        {errors.imageInfo && (<p className="text-danger">{errors.imageInfo.message}</p>)}
                                    </>
                            }
                            {/* {errors.imageFile && (<p className="text-danger">{errors.imageFile.message}</p>)} */}
                        </Col>
                    </Row>

                    {/* Button */}
                    <Row>
                        <Col>
                            <Button type="submit" variant="primary" className="mt-3 submitBtn" size="lg">
                                {id ? `Update` : `Create`}
                            </Button>
                            <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={() => navigate("/content-management")}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </form>
            </Card>
        </FormLoader>
    )
}

export default AddContentManagement;